<template>
  <img
    src="@/assets/days-switch.png"
    alt="天気・六曜切り替え"
    @click="$emit('click', $event)"
  />
</template>

<script>
export default {};
</script>
